export const fullScreenButtonClick = () => {
    const fullscreenButton: any = document.querySelector(
        '#dashboard button.image-gallery-fullscreen-button',
      );
      fullscreenButton && fullscreenButton.click();
}